@if (hasMultiplePractices()) {
  <p class="font-bold">{{ practiceName() }}</p>
}

<mat-form-field subscriptSizing="dynamic">
  <mat-label>Lab job income timestamp</mat-label>
  <mat-select
    [formControl]="labJobTimestamp"
    [disabled]="saving()"
    (selectionChange)="onChange()"
  >
    @for (option of labJobTimestampOptions; track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
